import { useQuery } from '@tanstack/react-query'

import { getTfaAppRecoveryCode } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchTfaAppRecoveryCode = (clicked: boolean) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })
  axiosInstance.defaults.responseType = 'blob'
  const { data, isError, isLoading } = useQuery({
    enabled: clicked,
    queryFn: () => getTfaAppRecoveryCode(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_TFA_APP_RECOVERY_CODE],
  })

  return { data, isError, isLoading }
}
